import { Injectable } from '@angular/core';
import { baseUrl } from 'libs/core/src/lib/configs/baseUrl';
import { IUsersService } from 'libs/core/src/lib/services/users.service';
import { RepresentativeService } from 'libs/core/src/lib/services/representative.service';
import {
  createQueryParams,
  IntermediaryPermissions,
  IRepresentative,
  IRepresentativeRequest,
  IUserQueryParams,
  PaginatedResponse,
} from '@inshuwa-client/models';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root',
})
export class AgentUsersService implements IUsersService {
  constructor(
    private rep: RepresentativeService,
    private http: HttpClient,
  ) {}

  updatePermissions(
    userId: number,
    request: Partial<IntermediaryPermissions>,
  ): Observable<IntermediaryPermissions> {
    return this.http.put<IntermediaryPermissions>(
      `${baseUrl()}/users/${userId}/permissions/intermediary`,
      request,
    );
  }

  getPermissions(userId: number): Observable<IntermediaryPermissions> {
    return this.http.get<IntermediaryPermissions>(
      `${baseUrl()}/users/${userId}/permissions/intermediary`,
    );
  }

  getUsers(
    queryParams: Partial<IUserQueryParams>,
  ): Observable<PaginatedResponse<IRepresentative>> {
    const insurerId =
      this.rep.getLoggedInAgentRepresentative().agent.insurer.id;
    return this.http.get<PaginatedResponse<IRepresentative>>(
      `${baseUrl()}/insurers/${insurerId}/representatives`,
      { params: createQueryParams(queryParams) },
    );
  }
  addUser(user: Partial<IRepresentativeRequest>): Observable<IRepresentative> {
    const id = this.rep.getLoggedInAgentRepresentative().agentId;
    return this.http.post<IRepresentative>(
      `${baseUrl()}/agencies/${id}/representatives`,
      user,
    );
  }
}
